import "./App.css";
import { Route, Routes, Navigate } from "react-router-dom";

import Homescreen from "./screens/homescreen";
import DetailScreen from "./screens/detailScreen";
import PreviewScreen from "./screens/previewScreen";
import { ConfigProvider } from "antd";
import NjayarPrabhaadhamAll from "./screens/NjayarPrabhaathamAll";
import VidyaprabhaathamAll from "./screens/VidyaPrabhaathamAll";

// Auth components
import LoginForm from "./components/auth/LoginForm";
import SignupForm from "./components/auth/SignupForm";
import EmailVerification from "./components/auth/EmailVerification";
import EmailVerificationNotice from "./components/auth/EmailVerificationNotice";
import ForgotPasswordForm from "./components/auth/ForgotPasswordForm";
import ResetPasswordForm from "./components/auth/ResetPasswordForm";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import SessionWatcher from "./components/auth/SessionWatcher";
import DeleteAccountScreen from "./screens/deleteScreen";
import Payment from "./screens/payment";
import PaymentSuccessPage from "./screens/payment/success";
import SettingsScreen from "./screens/settings";
import RenewLinkScreen from "./screens/renewLink";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "NotoSansMalayalam-SemiBold",
          colorPrimary: "rgb(5, 118, 183)",
          borderRadius: 2,
        },
      }}
    >
      <SessionWatcher />
      <Routes>
        {/* Auth routes */}
        <Route path="/login" element={<LoginForm />} />
        <Route path="/signup" element={<SignupForm />} />
        <Route path="/verify-email" element={<EmailVerification />} />
        <Route
          path="/verify-email-notice"
          element={<EmailVerificationNotice />}
        />
        <Route path="/forgot-password" element={<ForgotPasswordForm />} />
        <Route path="/reset-password" element={<ResetPasswordForm />} />
        <Route path="/delete-account" element={<DeleteAccountScreen />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/payment/result/:type" element={<PaymentSuccessPage />} />
        <Route path="/renew/:token" element={<RenewLinkScreen />} />

        {/* Protected routes */}
        <Route
          index
          element={
            <ProtectedRoute>
              <Homescreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Homescreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/details/:edition/:date/:page/:epaper_id"
          element={
            <ProtectedRoute>
              <DetailScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/preview"
          element={
            <ProtectedRoute>
              <PreviewScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/all-njayar-prabhaatham"
          element={
            <ProtectedRoute>
              <NjayarPrabhaadhamAll />
            </ProtectedRoute>
          }
        />
        <Route
          path="/all-vidya-prabhaatham"
          element={
            <ProtectedRoute>
              <VidyaprabhaathamAll />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <SettingsScreen />
            </ProtectedRoute>
          }
        />

        {/* Redirect any unknown routes to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ConfigProvider>
  );
}

export default App;
